module.exports = __webpack_public_path__ + "img/2.f7f305c9.jpeg";